export default __webpack_public_path__ + "static/media/1966.8e5eafd0.png";